/**
 * EncounterQueueChips Component
 *
 * Horizontal row of ready-to-bill filter chips for the encounters tab.
 * No queue-counts endpoint yet, so chips show labels only (no badge counts).
 * Uses the same toggle pattern as ClaimQueueChips and RemittanceQueueChips.
 */

import React from 'react';
import { Box, Chip, Stack } from '@mui/material';

import { READY_TO_BILL_FILTER_OPTIONS } from '../../constants/statusOptions';

interface EncounterQueueChipsProps {
  activeReadyToBill?: string;
  onReadyToBillSelect: (value: string | undefined) => void;
}

export const EncounterQueueChips: React.FC<EncounterQueueChipsProps> = ({
  activeReadyToBill,
  onReadyToBillSelect,
}) => {
  const handleClick = (key: string) => {
    if (activeReadyToBill === key) {
      onReadyToBillSelect(undefined);
    } else {
      onReadyToBillSelect(key);
    }
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', gap: 1 }}>
        {READY_TO_BILL_FILTER_OPTIONS.map(option => {
          const isActive = activeReadyToBill === option.value;

          return (
            <Chip
              key={option.value}
              label={option.label}
              color={option.color}
              variant={isActive ? 'filled' : 'outlined'}
              size="small"
              onClick={() => handleClick(option.value)}
              aria-label={`Filter by ${option.label} encounters`}
              sx={{
                cursor: 'pointer',
                fontWeight: isActive ? 600 : 400,
                '& .MuiChip-label': { fontSize: '0.8rem' },
              }}
            />
          );
        })}
      </Stack>
    </Box>
  );
};
